fabric.PDFObject = fabric.util.createClass(fabric.Object, {
    type: 'pdf-object',

    cacheProperties: fabric.Object.prototype.cacheProperties.concat('pdf', '_pdfCanvas', 'pdfColor'),
    pdf: null,
    coverMaskArea: false,

    _pdfCanvas: null,

    // This is only intended for TESTING
    _renderPromise: null,
    pdfColor: '',
    _colorFilter: null,

    initialize: function (options) {
        this.callSuper('initialize', options);
        this._colorFilter = new fabric.Image.filters.BlendColor({
            color: this.pdfColor,
            mode: 'tint',
            alpha: 1
        });
    },

    _loadPdf: function (pdfUrlOrFile) {
        const scope = this;
        return new Promise((resolve, reject) => {
            var url = '';
            if (typeof pdfUrlOrFile === 'string') {
                url = pdfUrlOrFile;
            }
            // Assume file, try to convert it to URL blob
            else {
                url = URL.createObjectURL(pdfUrlOrFile);
            }

            var loadingTask = pdfjsLib.getDocument(url);
            loadingTask.promise.then(
                function (pdf) {
                    console.log('PDF loaded');

                    // Fetch the first page only
                    var pageNumber = 1;
                    pdf.getPage(pageNumber).then(function (page) {
                        var viewport = page.getViewport({ scale: 1 });
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;

                        var renderContext = {
                            canvasContext: ctx,
                            viewport: viewport,
                            background: 'rgba(0,0,0,0)'
                        };
                        var renderTask = page.render(renderContext);
                        renderTask.promise.then(function () {
                            scope.set('_pdfCanvas', canvas);
                            scope.dirty = true;

                            // Apply scaling for cover if needed
                            scope._applyCoverScale();

                            scope.canvas.renderAll();
                            resolve();
                        });
                    });
                },
                function (reason) {
                    // PDF loading error
                    this._pdfViewport = null;
                    console.error(reason);
                    reject(reason);
                }
            );
        });
    },

    _set: function (key, value) {
        if (key === 'pdf') {
            this._renderPromise = this._loadPdf(value);
        } else if (key === 'pdfColor') {
            var alpha = new fabric.Color(this.pdfColor).getAlpha();
            this.opacity = alpha;
        }

        this.callSuper('_set', key, value);
    },

    _getPdfScalingToFit: function () {
        const w = this.width,
            h = this.height;
        let scale = 1;

        if (this._pdfCanvas.height > this._pdfCanvas.width) {
            scale = h / this._pdfCanvas.height;

            if (this._pdfCanvas.width * scale > w) {
                scale = w / this._pdfCanvas.width;
            }
        } else {
            scale = w / this._pdfCanvas.width;

            if (this._pdfCanvas.height * scale > h) {
                scale = h / this._pdfCanvas.height;
            }
        }

        return scale;
    },

    _applyCoverScale: function () {
        if (this.coverMaskArea && this._pdfCanvas && this._pdfCanvas.width && this._pdfCanvas.height) {
            const pdfScale = this._getPdfScalingToFit();

            const scaleX = this.width / (this._pdfCanvas.width * pdfScale);
            const scaleY = this.height / (this._pdfCanvas.height * pdfScale);
            const scale = Math.max(scaleX, scaleY);

            this.set('scaleX', scale);
            this.set('scaleY', scale);
        }
    },

    /**
     * @param {CanvasRenderingContext2D} ctx
     */
    _render: function (ctx) {
        if (this._pdfCanvas) {
            // Scale the PDF to fit into the object but keep the aspect ratio
            const scale = this._getPdfScalingToFit();

            // Center the PDF
            var x = -(this._pdfCanvas.width * scale) / 2,
                y = -(this._pdfCanvas.height * scale) / 2;
            ctx.translate(x, y);

            // Draw the scaled PDF
            ctx.scale(scale, scale);
            ctx.drawImage(this._pdfCanvas, 0, 0);

            // Apply the color filter if necessary
            if (this.pdfColor) {
                this._colorFilter.color = this.pdfColor;

                var imgData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height);
                this._colorFilter.applyTo2d({
                    imageData: imgData
                });
                ctx.putImageData(imgData, 0, 0);
            }
        }
    }
});
